
import React, { useEffect, useState } from 'react';
import CategoryTreeSelect from '../../containers/CategoryTreeSelect';
import { Modal as AntdModal, message } from 'antd';
import fetcher from '../../API/index';

function CategoryEditModal(props) {
  const { onClose, visible, productId, refreshProductInfo } = props || {};
  const [newCategories, setNewCategories] = useState();

  function onCategoriesChanged(value, nodeInfo) {
    if(nodeInfo.length >= 1) {
        return message.error("只能选中三级类目！");
    }
    if(value.length > 1) {
        return message.error("只能选中一个类目！");
    }
    setNewCategories(value)
  }

  function handleSave() {
        if (!newCategories || !productId) {
            return
        }
        fetcher.post(`/api/v1/products/${productId}/manual`, {
            'categoryIds': newCategories,
        }).then((res) => {
            message.success('修改成功')
            // refresh the product info
            refreshProductInfo && refreshProductInfo();
            onClose && onClose()
        }).catch((error) => {
            message.error(error.response && error.response.data && error.response.data.errors)
        });
  }

  return (
      <AntdModal
        title="修改分类"
        visible={visible}
        width='60%'
        onCancel={onClose}
        onOk={handleSave}
      >
        <div className='row mt-2'>
            <div className="col-md-3">
                <span className="label label-default">设置新的分类(Select New Category):</span>
            </div>
            <div className="col-md-9">
                <CategoryTreeSelect 
                    selectedCategories={newCategories}
                    onChange={onCategoriesChanged}
                    deprecateOldCategories={true}
                    dropdownStyle={{zIndex: 1001}}
                />
            </div>
        </div>
      </AntdModal>
  )
}

export default CategoryEditModal
